import { formatDateMixin } from "@/mixins/formatDateMixin"
import { DataType, CaseDetails } from "@/types"
import { CaseColumn } from "@/types/caseColumns"

export interface DataTypeFunctionDefinition {
	toCsvString: ((column: CaseColumn, value: any, label: string | null, record: CaseDetails) => string) | null
}

function mapUsersFromRole (record: any, value: any) {
	if (!value) return ""

	try {
		if (value.subRoles) {
			return value.subRoles.map((subRole: any) => subRole.title + ": " + mapUsersFromRole(record, subRole)).join(". ")
		} else {
			return value.users.map(
				(user: any) => {
					let userRoleString = ""
					let usersName = record.users!.find((u: { id: any; }) => u.id === user.id)
					if (usersName) {
						userRoleString = usersName.name
					}
					if (user.timeSpent) {
						userRoleString += " (" + user.timeSpent + ")"
					}
					return userRoleString
				}
			).join(", ")
		}
	} catch {}

	return ""
}

const listToCsvString: (column: CaseColumn, value: any, label: string | null, record: CaseDetails) => string = (column: CaseColumn, value: any, label: string | null) => {
	if (column.listLabel) {
		return Array.isArray(value)
			? value.map((i: any) => i[column.listLabel!]).join(", ")
			: label || ""
	}

	return value
		? label || value
		: ""
}

const DataTypeFunctions: { [key in DataType]?: DataTypeFunctionDefinition} = {
	[DataType.userRole]: {
		toCsvString: (column: CaseColumn, value: any, label: string | null, record: CaseDetails) =>
			value ? mapUsersFromRole(record, value) : ""
	},
	[DataType.dateTime]: {
		toCsvString: (column: CaseColumn, value: any) => {
			return value
				? formatDateMixin.methods.displayDateFromISOString(value)
				: ""
		}
	},
	[DataType.array]: {
		toCsvString: listToCsvString
	},
	[DataType.arrayMultiple]: {
		toCsvString: listToCsvString
	},
	[DataType.arrayData]: {
		toCsvString: listToCsvString
	},
	[DataType.boolean]: {
		toCsvString: (column: CaseColumn, value: any) => value ? "Yes" : "No"
	}
}
export default DataTypeFunctions
